import { defineComponent, PropType, ref } from "vue";
import InputText from "../../forms/InputText";
import Utils from "../../utils/Utils";
import UploadBox from "../../components/UploadBox";
import Offers from "../../components/Offers";
import Tracking from "../../utils/Tracking";
import { OfferJson, OrderJson } from "../../OrderForm";
import OfferUtils, { OfferTariff } from "../../utils/OfferUtils";

export default defineComponent({
    components: {
        InputText,
        Offers,
        UploadBox,
    },

    template: `
        <div ref="el" class="vhome">
            <div class="vhome__section1">
                <div v-if="html" v-html="html.header"></div>
            </div>

            <div class="vhome__section2">
                <Offers
                    v-if="offers"

                    :offers="offers"
                    :visible_groups="false"

                    @offer:click="onOfferClick($event)"
                />
            </div>

            <div class="vhome__more">
                <button type="button" class="button button--secondary" @click="$emit('more:click')">Wszystkie Taryfy</button>
            </div>

            <div v-if="html" v-html="html.body"></div>

            <div class="vhome__upload">
                <div class="vhome__upload-wrap">
                    <div class="wrapper wrapper--990">
                        <h2>Która oferta będzie dla mnie najkorzystniejsza?</h2>

                        <div class="vhome__upload-body">
                            <h3>Wgraj fakturę za prąd</h3>
                            <p>Na jej podstawie <b>zaproponujemy ofertę najlepiej dostosowaną do Twoich potrzeb</b>.</p>

                            <UploadBox
                                :options="options"

                                :visible_footer="false"

                                @next="$emit('upload:next')"
                            />
                        </div>
                    </div>
                </div>
            </div>

            <div v-if="html" v-html="html.footer"></div>
        </div>
    `,

    emits: [
        'offer:select',
        'more:click',
        'upload:next',
        'upload:noinvoice',
    ],

    props: {
        /** @var OrderJson */
        options: { type: Object as PropType<OrderJson>, required: true },
    },

    data() {
        return {
            html: null,
        };
    },

    async mounted() {
        await this.reload();

        $('.vhome__search .button', this.$refs.el).on('click', async (e) => {
            e.preventDefault();

            await Tracking.doEvent('click_business_offer');

            window.location.href = e.currentTarget.getAttribute('href');
        });

        $('.vhome__hero-more, .vhome__hero-badge', this.$refs.el).on('click', (e) => {
            Utils.scrollToEl($('.Offers'));
        });

        $('body').addClass('body--vhome');
    },

    unmounted() {
        $('body').removeClass('body--vhome');
    },

    setup(props, ctx) {
        const offers = ref(null as OfferJson[]);

        async function reload() {
            this.html = (await Utils.get('/api/pages/home')).html;

            let list = await OfferUtils.fetchOffers(OfferTariff.G11);

            offers.value = list;
        }

        async function onOfferClick(offer: OfferJson) {
            await Utils.setCart('offer', {
                offer_id: offer.id,
            });

            ctx.emit('offer:select', offer);
        }

        return {
            offers,

            reload,
            onOfferClick,
        };
    },
});
